import script from "./session-timeout-modal-component.vue?vue&type=script&setup=true&lang=js"
export * from "./session-timeout-modal-component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__